import { createContext } from 'react';
import type { CatalogAction, CatalogState } from '../types/store';

const storedView = sessionStorage.getItem('catalogView')
  ? JSON.parse(sessionStorage.getItem('catalogView')!)
  : {
      purchased: {
        sort: 'default' as 'default' | 'a-z' | 'z-a',
        grid: 3 as 1 | 2 | 3 | 4,
        filters: {
          searchQuery: null,
          collection: null,
          category: null,
          subCategory: null,
          individualBundle: null,
        },
        pageNumber: 1,
        productPerPage: 10,
      },
      related: {
        sort: 'default' as 'default' | 'a-z' | 'z-a',
        grid: 4 as 1 | 2 | 3 | 4,
        filters: {
          searchQuery: null,
          collection: null,
          category: null,
          subCategory: null,
          individualBundle: null,
        },
        pageNumber: 1,
        productPerPage: 10,
      },
      fullCatalog: {
        sort: 'a-z' as 'default' | 'a-z' | 'z-a', // setting default sort for full catalog
        grid: 3 as 1 | 2 | 3 | 4,
        filters: {
          searchQuery: null,
          collection: null,
          category: null,
          subCategory: null,
          individualBundle: null,
        },
        pageNumber: 1,
        productPerPage: 20,
      },
    };

export const initialCatalog = {
  isLoading: false,
  isUpdatingCart: false,
  ux: {
    showCartWidget: false,
    showNotification: false,
    showBulkRates: null,
    showFeeDescription: null,
    showUpsellDescription: null,
  },
  // add feature flags here
  feature: {
    // userInfo: cookies.get('_uic') === 'true',
  },
  isError: false,
  cart: sessionStorage.getItem('localCart') ? JSON.parse(sessionStorage.getItem('localCart')!) : null,
  products: {
    purchased: null,
    related: null,
    fullCatalog: null,
  },
  view: {
    ...storedView,
  },
};

// New granular contexts to minimize rerenders.
export const CatalogStateContext = createContext<CatalogState>(initialCatalog);
export const CatalogDispatchContext = createContext<React.Dispatch<CatalogAction>>(() => null);
// Slice contexts (optional consumers can subscribe only to what they need)
export const ProductsContext = createContext<CatalogState['products']>(initialCatalog.products);
export const ViewContext = createContext<CatalogState['view']>(initialCatalog.view as CatalogState['view']);
export const UxContext = createContext<CatalogState['ux']>(initialCatalog.ux);
export const CartContext = createContext<CatalogState['cart']>(initialCatalog.cart);
